<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
  
    <div class="row">
      <div class="col-8 text-left  text-md-left">
          <a class="fab fa-twitter font-icons"  href="https://x.com/Serendipiagame"></a>
          <a class="fab fa-instagram font-icons"  href="https://www.instagram.com/serendipiagames"></a>          
          <a class="fab fa-youtube font-icons"  href="https://www.youtube.com/@SerendipiaGames"></a>
          <a class="fab fa-steam font-icons"  href="https://store.steampowered.com/app/3506070/Teios_Journey/"></a>
          <a class="fa fa-envelope font-icons" href="mailto:info@serendipiagames.com" ></a>
          <a class="fab fa-tiktok font-icons" href="https://www.tiktok.com/@serendipiagames" ></a>
          
          
      </div>
      <div class="col-4 copyright copyright-footer text-right text-md-right d-flex align-items-center justify-content-end" style="height: 100%;">
          &copy; Serendipia Games 
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>

.font-icons {
  font-size: 1.5rem;
  color: #fff;
  padding: 10px;
  text-decoration: none;
  border-bottom: none;
}

.font-icons:hover,
.font-icons:focus {
  text-decoration: none;
  border-bottom: none;
}

.copyright-footer {
  padding-top: 12px;
}

</style>
